import useFetchQuery from './useFetchQuery';

const BOOKING_QUERY_PARAMS = {
    cursor: 0,
    limit: 1,
    list_type: 3,
};

/**
 *
 * @returns {{ data: object|null, refetch: function, isLoading: boolean }}
 */
function useCurrentTherapistBooking() {
    const { data, refetch, isLoading } = useFetchQuery({
        url: '/masseuse/bookings',
        method: 'get',
        params: BOOKING_QUERY_PARAMS,
        staleTime: 0,
        refetchOnMount: 'always',
        cacheTime: 0,
        onFetchSuccess: ({ data }) => data?.bookings?.[0] ?? null,
    });

    return {
        data: data ?? null,
        refetch,
        isLoading,
    };
}

export default useCurrentTherapistBooking;
